
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import Empty from "@/components/empty.vue";
import TemplateTransfer from "@/components/template-transfer-pc/template/template-transfer.vue";
import {
  GetGroupDetail,
  GetGroupTemList,
  GetTemDetail,
} from "@/request/common";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Empty,
    TemplateTransfer,
  },
})
export default class Name extends Vue {
  private group_id: any = "";
  private tem_id: any = "";
  private groupData: any = {};
  private list: any = [];
  private data: any = {};
  private updateWholeTem(e: any) {
    this.data.fields = e;
    this.$forceUpdate();
  }
  private changeTem(id: any) {
    this.tem_id = id;
    this.getData();
  }
  private getGroup() {
    GetGroupDetail(this, this.group_id).then((res: any) => {
      this.groupData = res.data;
    });
  }
  private getList() {
    const params: any = {
      params: {
        group: this.group_id,
      },
    };
    GetGroupTemList(this, params).then((res: any) => {
      this.list = res.data;
      if (!this.tem_id && res.data.length > 0) {
        this.tem_id = res.data[0].template.id;
        this.getData();
      }
    });
  }
  private getData() {
    GetTemDetail(this, this.tem_id).then((res: any) => {
      this.data = res.data;
    });
  }
  private mounted() {
    if (this.$route.query.group_id) {
      this.group_id = this.$route.query.group_id;
      this.getGroup();
      this.getList();
    }
    if (this.$route.query.tem_id) {
      this.tem_id = this.$route.query.tem_id;
      this.getData();
    }
  }
}
